(function($) {
    $('.sticky').stick_in_parent({
        inner_scrolling: true,
        offset_top: 120,
    });
})( jQuery );